import React, { Fragment, useMemo, useState } from "react";

import { generateClassString as gcs } from "../../../lib/helper/generateClassString";
import { useIsDesktop } from "../../../lib/hooks/mediaQueries";
import { useSafeScroll } from "../../../lib/hooks/useScrollHandler";
import { Button } from "../../Button";
import { UserNav } from "../User/user";

import * as styles from "./satelliteNavigation.module.less";

export function SatelliteNavigation({
    className,
    satelliteMainNavElements = [],
    hidden
}) {
    const [activeSubMenu, setActiveSubMenu] = useState(null);
    const scrollPositionReached = useSafeScroll(100);
    const isMobile = useIsDesktop();

    const sortedElements = useMemo(
        () =>
            satelliteMainNavElements.sort(
                ({ position: positionA }, { position: positionB }) =>
                    positionA - positionB
            ),
        [satelliteMainNavElements]
    );

    return (
        <div
            className={gcs(styles.satelliteNavWrapper, className, [
                hidden,
                styles.hidden
            ])}
        >
            <div
                className={gcs(
                    styles.satelliteContainer,
                    scrollPositionReached && !isMobile ? styles.onScroll : ""
                )}
            >
                {sortedElements.map(
                    ({
                        id,
                        name,
                        link,
                        externalUrl,
                        treeChildren: children
                    }) => {
                        const hasSubNav = children.length > 0;
                        const navigateProp = {
                            ...(hasSubNav
                                ? {
                                      ...(isMobile
                                          ? {
                                                onClick: () =>
                                                    setActiveSubMenu(
                                                        activeSubMenu === id
                                                            ? null
                                                            : id
                                                    ),

                                                icon: "chevronDown"
                                            }
                                          : {
                                                onMouseEnter: () =>
                                                    setActiveSubMenu(
                                                        activeSubMenu === id
                                                            ? null
                                                            : id
                                                    ),

                                                icon: "chevronDown"
                                            })
                                  }
                                : { to: link?.url || externalUrl })
                        };

                        return (
                            <Fragment key={id}>
                                <div className={styles.menu}>
                                    <Button
                                        className={gcs(
                                            styles.button,
                                            [id === activeSubMenu, styles.open],
                                            [hasSubNav, styles.hasSubNav]
                                        )}
                                        type="secondary"
                                        {...navigateProp}
                                        renderAs={
                                            isMobile && hasSubNav
                                                ? "button"
                                                : "link"
                                        }
                                        to={link?.url || externalUrl}
                                    >
                                        {name}
                                    </Button>

                                    {hasSubNav && (
                                        <div
                                            className={gcs(
                                                styles.subNavContainer,
                                                [
                                                    id === activeSubMenu,
                                                    styles.activeSubMenu
                                                ]
                                            )}
                                            onMouseLeave={() => {
                                                setActiveSubMenu(
                                                    activeSubMenu === id
                                                        ? null
                                                        : id
                                                );
                                            }}
                                        >
                                            {children
                                                .sort(
                                                    (
                                                        { position: positionA },
                                                        { position: positionB }
                                                    ) => positionA - positionB
                                                )
                                                .map(
                                                    ({
                                                        id,
                                                        name,
                                                        link,
                                                        externalUrl
                                                    }) => {
                                                        return (
                                                            <Button
                                                                key={id}
                                                                className={
                                                                    styles.button
                                                                }
                                                                type="secondary"
                                                                renderAs={
                                                                    isMobile &&
                                                                    !activeSubMenu
                                                                        ? "button"
                                                                        : "link"
                                                                }
                                                                to={
                                                                    link?.url ||
                                                                    externalUrl
                                                                }
                                                            >
                                                                {name}
                                                            </Button>
                                                        );
                                                    }
                                                )}
                                        </div>
                                    )}
                                </div>
                            </Fragment>
                        );
                    }
                )}
                {isMobile ? <UserNav /> : null}
            </div>
        </div>
    );
}
